document.addEventListener('turbolinks:load', function () { 
  const attachmentSection = document.getElementById("attachment-section");
  const options = document.querySelectorAll('input[name="another_requirement[kind]"]');
  const inputField = document.getElementById("another_requirement_other");
  const inputAttachment = document.querySelectorAll('input[name="another_requirement[attachment][]"]');
  const inputJustify = document.getElementById("justify");
  const divSegundaViaDiploma = document.getElementById("segunda_via_diploma");

  // Adiciona listener para cada opção de radio button
  options.forEach(function(option) {
    option.addEventListener("change", displayInputField);
  });

  // Função para exibir ou ocultar campos com base na seleção
  function displayInputField() {
    const inputValue = document.querySelector('input[name="another_requirement[kind]"]:checked');

    if (inputValue) {
      const selectedValue = inputValue.value;

      // Configuração do attachmentSection
      if (["Matriz Curricular/Conteúdo Programático/Ementa", "Transferência Interna", "Revisão de Avaliação ou 2º chamada", "Aproveitamento de Conhecimentos e Experiências Anteriores"].includes(selectedValue)) {
        attachmentSection.style.display = "none";
      } else {
        attachmentSection.style.display = "block";
      }
      
      // Configuração do inputField
      if (selectedValue === "Outros") {
        inputField.style.display = "block";
        inputField.required = true;
      } else {
        inputField.style.display = "none";
        inputField.value = "";
        inputField.required = false;
      }

      // Configuração dos inputAttachment
      if (["Diploma 2ª via", "Abono de Faltas", "Condição de Estudante-Trabalhador"].includes(selectedValue)) {
        inputAttachment.forEach(function (input) {
          input.required = true;
        });
      } else {
        inputAttachment.forEach(function (input) {
          input.required = false;
        });
      }

      // Configuração do inputJustify
      if (selectedValue === "Revisão de Avaliação ou 2º chamada") {
        inputJustify.required = true;
      } else {
        inputJustify.required = false;
      }

      // Configuração do inputJustify
      if (selectedValue === "Diploma 2ª via") {
        divSegundaViaDiploma.style.display = "block";
      } else {
        divSegundaViaDiploma.style.display = "none";
      }
    }
  }

  // Adiciona listener ao formulário para validação na submissão
  document.querySelector("form").addEventListener("submit", function(event) {
    const checkboxElement = document.querySelector('input[name="another_requirement[kind]"]:checked');
    if (checkboxElement) {
      if ((checkboxElement.value === "Outros") && (inputField.value.trim() === "")) {
        event.preventDefault();
        alert("Favor preencher o campo com a solicitação desejada ou escolha uma opção na lista.");
      }
    }
  });

  // Chama a função de exibição ao carregar a página para preservar o estado
  displayInputField(); // Chama a função para exibir campos com base na seleção atual
});
